<template>
    <div>
        <label>{{label}}</label> 
          <div v-for="(damageTypeGroup, index) in damageTypesChunked" :key="'damage_type_group_' + index" class="row">
            <div v-for="(damageType) in damageTypeGroup" :key="'damage_type_' + damageType.id" class="col-sm-6">
              <div class="grid-item">
                <label class="check-container" v-if="damageType.id == lastItemId">
                  {{damageType.label}}
                    <input 
                      v-taurus-validator="validators" 
                      :fieldlabel="validationFieldLabel"
                      type="checkbox" 
                      class="custom-control-input" 
                      :id="'damage_type_checkbox_' + damageType.id"  
                      v-model="selectedDamageTypes"
                      :value="damageType"
                      @change="handleDamageTypeClick(damageType)">
                  <span class="check-checkmark"></span>
                </label> 

                <label class="check-container" v-else>
                  {{damageType.label}}
                    <input 
                      type="checkbox" 
                      class="custom-control-input" 
                      :id="'damage_type_checkbox_' + damageType.id" 
                      v-model="selectedDamageTypes"
                      :value="damageType"
                      @change="handleDamageTypeClick(damageType)">
                  <span class="check-checkmark"></span>
                </label>         
              </div>
            </div>
          </div>
          <div :name="'damage_type_checkbox_' + lastItemId" :invalidfeedback="validationInvalidFeedback"></div>
    </div>
</template>
<script>
const chunk = (arr, chunkSize, cache = []) => {
  const tmp = [...arr]
  while (tmp.length) cache.push(tmp.splice(0, chunkSize))
  return cache
}

export default {
    props: {
        value: { required: true },
        id: { required: true },
        label: { required: true },
        values: { required: true },
        validationFieldLabel: {required:true},
        validationInvalidFeedback: {required:true},
        validators: {required:true}
    },
    components: {
        
    },
    data: () => {
        return {
            selectedDamageTypes: []
        }
    },
    mounted() {
        this.selectedDamageTypes = this.value
    },
    computed: {
        lastItem() {
            if (this.values && Array.isArray(this.values)) {
                return this.values[this.values.length -1];
            }
        },
        lastItemId() {
            if (this.lastItem) {
                return this.lastItem.id
            } else {
                return null
            }
        },
        damageTypes() {
            if (this.values && Array.isArray(this.values)) {
                return this.values
            }
        },
        damageTypesChunked () {
            if (this.damageTypes && this.damageTypes.length > 0) {
                let chunkSize = Math.ceil(this.damageTypes.length / 2)
                return chunk(this.damageTypes, chunkSize)
            }
        },
    },
    watch:{
        value(newVal,oldVal) {
            if (newVal != this.selected) {
                this.selectedDamageTypes = this.value
            }
        },
    },
    methods: {
        handleDamageTypeClick (selectedDamageType) {
          this.$emit('input', this.selectedDamageTypes)
        },
    }
}
</script>